export const getFormattedFilename = function (filename: string): string {
   return filename.replace(/[-_\s]+/g, ' ').replace(/\w\S*/g, function (txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1);
   });
};
